import { useCallback, useEffect, useState } from 'react'

export default function useCalculateContentSpace({
  refs,
}: {
  refs: Array<React.RefObject<HTMLElement>>
}) {
  const [contentHeight, setContentHeight] = useState(0)
  const [totalPageHeight, setTotalHeight] = useState(() => window.innerHeight)
  const calculateContentHeight = useCallback(() => {
    return refs.reduce((acc, ref) => {
      return acc + (ref.current?.offsetHeight ?? 0)
    }, 0)
  }, [refs])

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const _contentHeight = calculateContentHeight()
      setContentHeight(_contentHeight)
      setTotalHeight(window.innerHeight)
    })
    observer.observe(document.body)
  }, [calculateContentHeight, refs])

  return {
    height: contentHeight,
    pageHeight: totalPageHeight,
    availableSpace: totalPageHeight - contentHeight,
  }
}
